import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/anime';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${s.image})` }}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-background-50" />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-3xl w-full">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-medium bg-primary-500/20 text-primary-400 rounded-full border border-primary-500/30">
            51动漫官网 · 国产精品入口
          </span>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white font-heading mb-3 leading-tight">
            {slide.title}
          </h1>
          <p className="text-base md:text-lg text-white/80 font-heading mb-3">
            {slide.subtitle}
          </p>
          <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-6">
            {slide.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to={slide.link}
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即查看
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/rexue-zhandou"
              className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              浏览更多
              <i className="ri-compass-3-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`第${i + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo(current - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={() => goTo(current + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}